<section id="user-manager-container">
  <app-header title="User Manager">
    <mat-toolbar class="filter-toolbar">
      <form [formGroup]="form" class="user-manager-filter">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Search users</mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input
            matInput
            type="search"
            autocomplete="off"
            [formControl]="keywords" />
        </mat-form-field>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>Role</mat-label>
          <mat-select [formControl]="userRole" [disabled]="rolesLoading">
            <mat-option [value]="null">All roles</mat-option>
            @for (role of roles; track role.Id) {
              <mat-option [value]="role.Id">{{ role.RoleName }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <button
          type="button"
          mat-button
          class="clear-filters-button"
          [disabled]="!hasActiveFilters"
          (click)="clearFilters()">
          Clear filters
        </button>
        <span class="filter-spacer"></span>
        @if (!loading && !loadError) {
          <span class="result-count" aria-live="polite">
            {{ users.length }} {{ users.length === 1 ? 'user' : 'users' }}
          </span>
        }
        <button type="button" mat-raised-button [routerLink]="['add']">
          <mat-icon>person_add</mat-icon>
          Add user
        </button>
      </form>
    </mat-toolbar>
    @if (roleLoadError) {
      <p class="role-filter-error" role="alert">{{ roleLoadError }}</p>
    }
  </app-header>

  <div class="container user-table-container">
    @if (loading) {
      <section class="user-state" role="status" aria-live="polite">
        <mat-spinner diameter="44"></mat-spinner>
        <h2>Loading users</h2>
        <p>Please wait while the user list is refreshed.</p>
      </section>
    } @else if (loadError) {
      <section class="user-state error-state" role="alert">
        <mat-icon>error_outline</mat-icon>
        <h2>Users could not be loaded</h2>
        <p>{{ loadError }}</p>
        <button mat-raised-button type="button" (click)="updateResults()">
          Try again
        </button>
      </section>
    } @else if (users.length === 0) {
      <section class="user-state" role="status">
        <mat-icon>person_search</mat-icon>
        <h2>No users found</h2>
        <p>
          @if (hasActiveFilters) {
            No users match the current search and role filters.
          } @else {
            There are no users to display.
          }
        </p>
        @if (hasActiveFilters) {
          <button mat-raised-button type="button" (click)="clearFilters()">
            Clear filters
          </button>
        }
      </section>
    } @else {
      <div class="table-scroll-container">
        <table mat-table [dataSource]="users" aria-label="User management">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let user">
              <a [routerLink]="['/users', user.Id]">{{ user.LastFirst }}</a>
            </td>
          </ng-container>

          <ng-container matColumnDef="identity">
            <th mat-header-cell *matHeaderCellDef>Identity</th>
            <td mat-cell *matCellDef="let user">
              <strong>{{ displayHawkId(user) || '—' }}</strong>
              @if (user.Email) {
                <span>{{ user.Email }}</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="roles">
            <th mat-header-cell *matHeaderCellDef>Roles</th>
            <td mat-cell *matCellDef="let user">
              @if (visibleRoles(user).length > 0) {
                <span>{{ visibleRoles(user).join(', ') }}</span>
              } @else {
                <span class="no-roles">None</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
              <span class="visually-hidden">Actions</span>
            </th>
            <td mat-cell *matCellDef="let user" class="user-actions">
              <button
                matIconButton
                [routerLink]="['/users', user.Id]"
                aria-label="Edit {{ user.LastFirst }}">
                <mat-icon>edit</mat-icon>
              </button>
              <button
                matIconButton
                (click)="removeUser(user)"
                aria-label="Remove {{ user.LastFirst }}">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    }
  </div>
</section>
